import { IPricesV2, IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';

import { IShopItem, IShopPriceV2 } from '~/src/api/content/shop/getShopItems';
import { IMultibundleAdditional, multiBundleId } from '~/src/store/selectors/vas';

import { IPriceOptions } from '../types';

const shopItemsPrices: IPriceOptions[] = [
    {
        count: 2,
        discount: 61,
        price: 290,
    },
    {
        count: 3,
        discount: 63,
        price: 390,
    },
];

const getPromoPrice = (prices: IShopPriceV2[]): IPricesV2[] => {
    const prepared: IPricesV2[] = [];
    const promoPrice = prices.find(price => !!price.value && !!price.duration);
    if (promoPrice) {
        prepared.push({
            discount: 0,
            duration: promoPrice.duration,
            lifeTimePromoTypeId: 1,
            type: promoPrice.type,
            value: promoPrice.value,
            raGroups: [],
        });
    }

    return prepared;
};

export const content2VasSubscription = (data: IShopItem[]): Partial<IVasInfo<IMultibundleAdditional>>[] => {
    return data.map(subscriptionItem => {
        return {
            advertising: subscriptionItem.advertising,
            vasId: subscriptionItem.global_id,
            serviceId: subscriptionItem.global_id,
            body: subscriptionItem.body,
            nameVas: subscriptionItem.global_id === multiBundleId
                ? 'Подписки выгоднее, если брать сразу несколько'
                : subscriptionItem.title,
            activeVas: 0,
            buttonText: subscriptionItem.button_text,
            buttonLink: subscriptionItem.button_link,
            includedAgr: 0,
            image: subscriptionItem.image_widgets,
            imageWebp: subscriptionItem.image_widgets_webp,
            body_full: subscriptionItem.body_full,
            title: subscriptionItem.title,
            priceVas: subscriptionItem.pricesV2 ? subscriptionItem.pricesV2[0]?.value : 0,
            contentData: {
                alias: subscriptionItem.alias,
                body: subscriptionItem.body,
            },
            additionalProps: {
                priceOptions: shopItemsPrices,
                subscriptionsSocIds: {
                    active: [],
                    inactive: [],
                },
            },
            pricesV2: getPromoPrice(subscriptionItem.pricesV2),
        };
    });
};
